import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { CIRROM_URL } from "../api/api";

/**
 * Okta hands the browser back to /authenticate-via-okta. Where the app is registered
 * against the web app url rather than the api url that lands here, on the UI, so forward
 * the code/state on to the api endpoint that can actually complete the exchange.
 * It has to be a top level navigation - the api sets the session cookie and then redirects
 * back into the app, neither of which survive an XHR.
 */
export function OktaCallback() {
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const search = window.location.search;

    if (!new URLSearchParams(search).get("code")) {
      setError(
        "Okta did not return an authorization code. Please try signing in again."
      );
      return;
    }

    const target = new URL(
      `${(CIRROM_URL || "").replace(
        /\/+$/,
        ""
      )}/authenticate-via-okta${search}`,
      window.location.origin
    );

    if (
      target.origin === window.location.origin &&
      target.pathname === window.location.pathname
    ) {
      // apiUrl is missing or points back at the UI, so forwarding would just loop.
      setError(
        "Unable to complete the Okta sign in because Cirrom is not configured with an API url. Please reach out to your IT team."
      );
      return;
    }

    window.location.replace(target.toString());
  }, []);

  return (
    <Box
      style={{
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
        height: "100px",
        justifyContent: "center",
        marginTop: "50px",
      }}
    >
      <Container maxWidth="sm" style={{ textAlign: "center" }}>
        {!error && <CircularProgress />}
        {error && <Typography variant={"h4"}>{error}</Typography>}
      </Container>
    </Box>
  );
}
